<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Monitoramento (Serviço Push)</h5>
                <hr>	
				
				<div class="p-col-12 p-md-12" v-if="exibirProgresso"> 
					{{ statusEquipamentoEmSincronizacao }}...<i class="pi pi-spin pi-spinner" ></i>
					<ProgressBar :value="progresso" class="p-mb-2"/>
					<Message severity="warn" :closable="false">
						O sistema listou equipamentos com o serviço Push Async. 
						<br>Você poderá continuar navegando normalmente, <span class="ik-text-danger">porém, caso faça logout ou feche a aba/navegador, o processo em andamento será cancelado</span>.
						<br>A monitoração será realizada apenas para os equipamentos com o serviço Push Async.
					</Message>
				</div>

                <DataTable :value="relogiosPush" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped" :selection.sync="relogioPontoPushSelecionado" 
					selectionMode="single" @row-select="exibirMensagenStatus">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-between">	
								<div>
									<Dropdown v-model.number="idCnpjsSelecionado" :options="cnpjs" 
										optionLabel="cnpjNome" optionValue="id" 
										placeholder="Selecione uma empresa" 
										@change="listarRelogios" :disabled="exibirProgresso"/>
									<Button label="Atualizar" icon="pi pi-refresh" class="p-ml-3" 
										v-if="idCnpjsSelecionado" @click="atualizar"/>
									<Button label="Sincronizar..."
										class="p-button-secondary p-mt-3 p-ml-3" icon="pi pi-refresh" 
										@click="exibirOpcoesSincronismo" v-if="relogiosPush.length > 0 && permissaoEditar && !exibirProgresso"/>
								</div>			
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>                   
					<Column field="modelo" header="Modelo"></Column>	
					<Column field="numeroSerie" header="Número de Série"></Column>						
					<Column field="localInstalacao" header="Local"></Column>	
					<Column field="funcionariosSincronizar" header="Funcionários para Sincronizar"></Column>	
					<Column field="dataUltimaConexao" header="Última Conexão">
						<template #body="slotProps">
							{{ formatarDataHora(slotProps.data.dataUltimaConexao) }}
						</template>	
					</Column>
					<Column field="dataUltimaSincronizacao" header="Última Sincronização">
						<template #body="slotProps">
							{{ formatarDataHora(slotProps.data.dataUltimaSincronizacao) }}
						</template>	
					</Column>					
					<Column field="status" header="Status">
						<template #body="slotProps">
							<span class="p-text-bold" :class="slotProps.data.status == 'Autenticado' ? 'ik-badge-success' : 'ik-badge-danger'" >
								{{ slotProps.data.status }}
							</span>						
						</template>	
					</Column>	
					<Column>
						<template #body="slotProps">
							<SplitButton label="Ações" class="p-button-secondary" :model="maisAcoes(slotProps.data)" appendTo="body" ></SplitButton>
						</template>
					</Column>			
				</DataTable>			

            </div>
			
        </div>		

		<Dialog :visible.sync="exibirDialogAtualizarNSR" header="Atualizar NSR" :modal="true" class="p-fluid" :style="{width: '45vw'}" @hide="fecharModal">					
			<div class="p-fluid p-formgrid p-grid" v-if="relogioPontoPushSelecionado">				
				<div class="p-field p-col-12">
					<label>Local</label>
					<InputText v-model.trim="relogioPontoPushSelecionado.localInstalacao" class="ik-background-color-input-readonly" readonly/>					
				</div>				
				<div class="p-field p-col-6">
					<label>Modelo</label>
					<InputText v-model.trim="relogioPontoPushSelecionado.modelo" class="ik-background-color-input-readonly" readonly/>
				</div>
				<div class="p-field p-col-6">
					<label>Número de Série</label>
					<InputText v-model.trim="relogioPontoPushSelecionado.numeroSerie" class="ik-background-color-input-readonly" readonly/>				
				</div>
				<div class="p-field p-col-4">
					<label>NSR</label>
					<InputText v-model="proximoNSR" @keyup="validarSomenteNumeros($event)" required="true"/>		
					<small class="p-invalid" v-if="enviandoForm && (!proximoNSR || proximoNSR <= 0)">Informe o NSR</small>		
				</div>
				<div class="p-field p-col-12">
					<Message severity="warn" :closable="false">
						<h4>Atenção!</h4>
						<p>O valor do NSR (Número Sequencial) é a referência para coletar as marcações no equipamento.</p>						
					</Message>
				</div>				
			</div>			
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Salvar" icon="pi pi-check" @click="atualizarNSR" />
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogConfirmarAtivarDesativar" header="Confirmar" :modal="true" :style="{width: '450px'}" @hide="fecharModal">
			<div class="confirmation-content" v-if="relogioPontoPushSelecionado">
				<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
				<span v-if="relogioPontoPushSelecionado.status == 'Autenticado'">Parar Monitoramento do Serviço Push?</span>
				<span v-else-if="relogioPontoPushSelecionado.status == 'Parado'">Ativar Monitoramento do Serviço Push?</span>
				<span v-else-if="relogioPontoPushSelecionado.status == 'Erro'">Ativar Monitoramento do Serviço Push?</span>
				<br/><br/>
				<label><b>Modelo</b>: {{ relogioPontoPushSelecionado.modelo }}</label><br/>
				<label><b>Número Série</b>: {{ relogioPontoPushSelecionado.numeroSerie }}</label>				
			</div>
			<template #footer>
				<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="ativarDesativar" />
			</template>
		</Dialog>	

		<Dialog :visible.sync="exibirDialogMensagemErro" header="Mensagem" :modal="true" :style="{width: '30vw'}" @hide="fecharModal">
			<div class="confirmation-content" v-if="relogioPontoPushSelecionado">
				<p>{{ relogioPontoPushSelecionado.mensagem }}</p>			
			</div>
			<template #footer>
				<Button label="OK" icon="pi pi-check" @click="exibirDialogMensagemErro=false"/>
			</template>
		</Dialog>
		
		<Dialog :visible.sync="exibirDialogValidarAutenticacao" header="Autenticação" :modal="true" :style="{width: '450px'}" :closable="false">
			<div class="confirmation-content">
				<i class="pi pi-exclamation-triangle p-mr-3 ik-text-warnning" style="font-size: 2rem;" />Aguarde!
				<p>Checando status de conexão do equipamento...<i class="pi pi-spin pi-spinner" ></i></p>			
			</div>
		</Dialog>

		<SincronizacaoPush ref="dialogSincronizacaoPush" :iniciarSincronizacaoPushAsync="iniciarSincronizacaoPushAsync"/>

    </div>
</template>

<script>
import RelogioPontoService from '@/service/RelogioPontoService.js';
import SincronizacaoPush from '@/components/pages/cadastro/dispositivosColetas/sinc/Sincronizacao.vue';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
	relogioPontoService: null,
    data() {
        return {
			relogiosPush: [],		          
			relogioPontoPushSelecionado: null,		
			cnpjSelecionado: null,	
			cnpjs: [],			
			filtro: {},	
			idCnpjsSelecionado: null,
			idRelogioSelecionado: null,
			numeroSequencialAfd: null,
			exibirDialogAtualizarNSR: false,
			exibirDialogMensagemErro: false,
			exibirDialogConfirmarAtivarDesativar: false,	
			exibirDialogValidarAutenticacao: false,
			enviandoForm: false,
			proximoNSR: '',
			dataUltimoCliqueCalc: null,
			statusEquipamentoEmSincronizacao: '',
			progresso: 0,
			exibirProgresso: false
        }        
    },
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getPermissoes', 'getCacheEmpresa']),				
		/**
		 * 
		 */
		atualizarNSR() {
			this.enviandoForm = true;
			if(!this.relogioPontoPushSelecionado.nsr || this.relogioPontoPushSelecionado.nsr <= 0) {
				return;
			}
			let requisicao = {
				nsr: this.relogioPontoPushSelecionado.nsr,
				id: this.relogioPontoPushSelecionado.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.relogioPontoService.atualizarNSR(requisicao)
			.then(resp => {
				exibirMensagem(this, resp);
				this.fecharModal();
				this.listarRelogios();							
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		ativarDesativar() {	
			let requisicao = {				
				id: this.relogioPontoPushSelecionado.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			const cnpjSelecionado = this.cnpjs.find(cnpj => cnpj.id == this.idCnpjsSelecionado);	
			if(this.relogioPontoPushSelecionado.status == 'Parado' 
				|| this.relogioPontoPushSelecionado.status == 'Erro') {
				this.relogioPontoService.ativarMonitoramento(requisicao)
				.then(resp => {	
					exibirMensagem(this, resp);
					this.fecharModal();					
					if(this.relogioPontoPushSelecionado.tipoServico == 'Push Async') {
						this.exibirDialogValidarAutenticacao = true;
						this.$webSocketPushSyncManager.validarAutenticacao(cnpjSelecionado, {...this.relogioPontoPushSelecionado}, () => {
							this.exibirDialogValidarAutenticacao = false;
							this.listarRelogios();
						});
					} else {
						this.listarRelogios();
					}						
				})
				.catch(erro => {exibirMensagem(this, erro)});				
			} else {
				this.relogioPontoService.desativarMonitoramento(requisicao)
				.then(resp => {	
					exibirMensagem(this, resp);
					this.fecharModal();
					this.listarRelogios();												
				})
				.catch(erro => { console.log(erro); exibirMensagem(this, erro)});
			}			
		},		
		/**
		 * 
		 */
		atualizar() {
			if(this.dataUltimoCliqueCalc != null) {			
				const diffTimeClick = new Date().getTime() - this.dataUltimoCliqueCalc.getTime();
				if(diffTimeClick < 5000) {          
					return;
				}
			}       
			this.dataUltimoCliqueCalc = new Date();
			this.listarRelogios();
		},
		/**
		 * callback para SincronizacaoPush
		 */
		iniciarSincronizacaoPushAsync(requisicao) {
			if(requisicao.sincronizacaoGeral) {
				this.listarRelogiosNaSincronizacaoComPushAsync();
			} else if (requisicao.relogiosTarefaPendentes.length > 0){
				this.iniciarWebSocketSincronizacaoPushAsync([...requisicao.relogiosTarefaPendentes]);
			}
		},
		/**
		 * 
		 */
		listarRelogiosNaSincronizacaoComPushAsync() {			
			const tipos = ['DELETE_ALL_USERS', 'SYNC_ALL_USERS', 'IMPORT_ALL_IMAGES'];
			const cnpjSelecionado = this.cnpjs.find(cnpj => cnpj.id == this.idCnpjsSelecionado);			
			this.relogioPontoService.listarTarefasComServicoPushAsync(this.idCnpjsSelecionado)
			.then(resp => {					
				if(resp.data.length > 0) {
					const tarefasPushAsync = resp.data;					
					const relogiosPushAsync = [];
					this.relogiosPush.forEach(r => {						
						const tarefas = tarefasPushAsync.filter((t) => t.idRelogio == r.id);						
						if(tarefas.length > 0) {
							const tarefasFiltradas = tarefas.filter(t => tipos.includes(t.tipo));
							relogiosPushAsync.push({
								id: r.id,
								numeroCnpj: cnpjSelecionado.numero,
								numeroSerie: r.numeroSerie,
								tarefas: tarefasFiltradas
							});
						}						
					});
					this.iniciarWebSocketSincronizacaoPushAsync(relogiosPushAsync);
				}				
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		iniciarWebSocketSincronizacaoPushAsync(relogiosPushAsync) {
			const cnpjSelecionado = this.cnpjs.find(cnpj => cnpj.id == this.idCnpjsSelecionado);
			this.exibirProgresso = true;
			this.progresso = 0;
			this.$webSocketPushSyncManager.sincronizar({...cnpjSelecionado}, relogiosPushAsync, (resposta) => {
				this.atulizaProgressoPushAsync(resposta);
			});
		},
		/**
		 * 
		 */
		atulizaProgressoPushAsync(resposta) {
			this.exibirProgresso = true;
			this.progresso = resposta.progresso;
			this.statusEquipamentoEmSincronizacao = `Sincronizando equipamento ${resposta.numeroSerie}. Última atualização ${new Date().toLocaleString('pt-BR')}`;
			if(resposta.status === 'erro' || resposta.status === 'desconectado') {
				setTimeout(() => {
					this.progresso = 0;
					this.exibirProgresso = false;
				}, 1500);
				exibirMensagemSis(this, resposta.mensagem, true);
				this.listarRelogios();
				return;
			}
			if(this.progresso >= 100 || resposta.status === 'sincronizado') {	
				setTimeout(() => {			
					this.progresso = 100;
					this.exibirProgresso = false;
					this.progresso = 0;	
				}, 1500);			
				this.listarRelogios();
				exibirMensagemSis(this, 'Sincronização finalizada para os equipamentos com serviço Push Async', false);				
			}
		},
		/**
		 * 
		 */
		verificarSincronismoPushAsyncAtivo() {
			this.idCnpjsSelecionado = null;
			this.progresso = 0;
			this.exibirProgresso = false;
			if(this.$webSocketPushSyncManager.sincronizando()) {				
				const statusProgresso = this.$webSocketPushSyncManager.setOnMessageCallback((resposta) => {
					this.atulizaProgressoPushAsync(resposta);
				});
				this.idCnpjsSelecionado = statusProgresso.idCnpjSelecionado;
				this.listarRelogios();			
				this.atulizaProgressoPushAsync(statusProgresso);
				this.statusEquipamentoEmSincronizacao = `Sincronizando equipamento ${statusProgresso.numeroSerie}. Última atualização ${new Date().toLocaleString('pt-BR')}`;
				this.exibirProgresso = true;				
			}
		},
		/**
		 * 
		 */
		listarRelogios() {			
			if(this.idCnpjsSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }			
			let cnpjSelecionado = null;
			this.cnpjs.forEach(cnpj => {
				if(cnpj.id == this.idCnpjsSelecionado) {
					cnpjSelecionado = {...cnpj};
				}
			});
			this.relogioPontoService.listarMonitoramentoPushPorCnpj(cnpjSelecionado.id)
			.then(resp => {	
				this.relogiosPush = resp.data;
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		buscar() {			
			this.relogioPontoService.buscarRepMonitoramento(this.relogioPontoPushSelecionado.id)
			.then(resp => {	
				this.relogioPontoPushSelecionado.nsr = resp.data.nsr;
				this.proximoNSR = resp.data.nsr;
				this.exibirDialogAtualizarNSR = true;
			})
			.catch(erro => {exibirMensagem(this, erro)});
		},
		/**
		 * 
		 */
		listarCnpjs() {
			// Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;  
			this.verificarSincronismoPushAsyncAtivo();				
		},
		/**
		 * 
		 */
		exibirOpcoesSincronismo() {
			if(this.idCnpjsSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }			
			let cnpjSelecionado = null;
			this.cnpjs.forEach(cnpj => {
				if(cnpj.id == this.idCnpjsSelecionado) {
					cnpjSelecionado = {...cnpj};
				}
			});
			this.$refs.dialogSincronizacaoPush.exibir({relogios: this.relogiosPush, cnpj: cnpjSelecionado});
		},
		/**
		 * 
		 */
		exibirMensagenStatus() {
			if(this.relogioPontoPushSelecionado.status == 'Erro') {
				this.exibirDialogMensagemErro = true;
			}
		},
		/**
		 * 
		 */
		fecharModal() {
			this.enviandoForm = false;
			this.exibirDialogAtualizarNSR = false;
			this.exibirDialogConfirmarAtivarDesativar = false;
			this.exibirDialogMensagemErro = false,
			this.exibirDialogConfirmarExcluir = false;
		},
		/**
		 * 
		 */
		validarSomenteNumeros() {
			this.proximoNSR = this.proximoNSR.replace(/\D/g, '');
			if(this.proximoNSR) {
				this.relogioPontoPushSelecionado.nsr = Number(this.proximoNSR);
			}		 
		},
		/**
		 * 
		 */
		formatarDataHora(strData) {       
			if(!strData) {
				return '';
			}     
            let partesData = strData.split(' ');
            let camposData = partesData[0].split('-');
            let data = camposData[2]+'/'+camposData[1]+'/'+camposData[0];
            let camposHora = partesData[1].split(':');            
            return data+' '+camposHora[0]+':'+camposHora[1];
        },
		/**
		 * 
		 * 
		 */
		maisAcoes(repPush) {
			let labelAtivarDesativar = 'Parar Serviço';
			if(repPush.status == 'Parado' || repPush.status == 'Erro') {
				labelAtivarDesativar = 'Ativar Serviço';
			}
			let acoes = [];
			if(this.permissaoEditar) {
				if(repPush.tipoServico == 'Push Sync') {
					acoes.push({label: 'Atualizar NSR', icon: 'pi pi-pencil', idRepPush:repPush.id, command: (event) => { 		
						if(this.exibirProgresso) {
							return;
						}			                       
                        for(let i = 0; i < this.relogiosPush.length; i++) {
                            if(this.relogiosPush[i].id == event.item.idRepPush) {								
                                this.relogioPontoPushSelecionado = this.relogiosPush[i];      
								this.buscar();                         
                                break;
                            }
                        } 
                    }
                });
				}
				acoes.push({label: labelAtivarDesativar, icon: 'pi pi-eye', idRepPush:repPush.id, command: (event) => {    
						if(this.exibirProgresso) {
							return;
						}                            
                        for(let i = 0; i < this.relogiosPush.length; i++) {
                            if(this.relogiosPush[i].id == event.item.idRepPush) {
                                this.relogioPontoPushSelecionado = this.relogiosPush[i];
                                this.exibirDialogConfirmarAtivarDesativar = true;
                                break;
                            }
                        } 
                    }
                });
			}			          
            return acoes;
        },
		/**
		 * 
		 */
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoEditar = permissoes.includes(174);	
		}
	},
	created() {
		this.relogioPontoService = new RelogioPontoService();
		this.validarPermissoes();
	},
	mounted() {		
		this.listarCnpjs();
	},	
	components: {
		'SincronizacaoPush': SincronizacaoPush
	}
}
</script>
